import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { State as SharedState } from '@emm/shared/store/shared.reducer';
import { ShowTagsActions } from './show-tags.actions';
import { ShowTagsSelectors } from './show-tags.selectors';

export interface ShowTagsQueries {
    showTags$: Observable<string>;
}

@Injectable({ providedIn: 'root' })
export class ShowTagsStoreService {

    dispatch = {
        initShowTags: () => this.store.dispatch(ShowTagsActions.init()),
        selectShowTags: (showTags: string) => this.store.dispatch(ShowTagsActions.selectShowTags({showTags})),
    };

    queries: ShowTagsQueries = {
        showTags$: this.store.select(ShowTagsSelectors.getShowTags),
    };

    constructor(private store: Store<SharedState>) { }

}
